/* eslint-disable no-unused-vars */
import { ButtonBase } from "@mui/material";
import styled from "styled-components";
import { CONTRACT_STATUS } from "../../constants";
import { ContractSubTitle } from "../../titles";
import styles from "./styles.module.css";

const Img = styled("img")({
  // display: "block",
  width: "40px",
  height: "40px",
  borderRadius: "50%",
});

interface Props {
  img?: string;
  title?: string;
  backGroundColor?: string;
  description?: string;
}

const StatusAlt = ({ img, title, backGroundColor, description }: Props) => {
  return (
    <div className={styles.statusCard} style={{ background: backGroundColor }}>
      <div className={styles.row}>
        <ButtonBase>
          <Img alt="" src={img} />
        </ButtonBase>
        <div className={styles.text_wrapper}>
          <p className={styles.title}>{title}</p>
          <p className={styles.description}>{description}</p>
        </div>
      </div>
    </div>
  );
};

export default StatusAlt;
